// Explicit sections in the master document; never infer duties from prose.
export function parseSopRoleSections(content) {
  const source = String(content || '');
  const parts = [];
  const pattern = /^\[\[ROLE: ([a-z0-9_, ]+)\]\]\r?\n([^\n]+)\r?\n([\s\S]*?)^\[\[END ROLE\]\][ \t]*(?:\r?\n|$)/gm;
  let end = 0;
  let match;
  while ((match = pattern.exec(source))) {
    if (match.index > end) parts.push({text:source.slice(end, match.index)});
    parts.push({roles:match[1].split(',').map(r => r.trim()).filter(Boolean), title:match[2].trim(), text:match[3].trim()});
    end = pattern.lastIndex;
  }
  if (end < source.length) parts.push({text:source.slice(end)});
  // Malformed markers must not silently hide any part of the master SOP.
  if (parts.some(p => /\[\[(?:ROLE:|END ROLE)/.test(p.text))) return [{text:source}];
  return parts.length ? parts : [{text:source}];
}
export function responsibilitiesForRole(parts, role) {
  return parts.filter(part => part.roles?.includes(role));
}
